<template>
  <div class="seckill-list-block-component">
    <ym-img class="seckill-list-block-title"
            :src="block.title"
    />
    <div class="seckill-list-block-list">
      <list-item v-for="item in block.list"
                 :key="item.target.id"
                 :item="item"
                 @show-book-mobile="handleShowBookPopup"
                 @show-next-seckill="handleShowNextSeckill"
      />
    </div>
  </div>
</template>

<script>
  import ListItem from '@/pages/Seckill/components/SeckillListItem';

  export default {
    name: 'seckillListBlock',
    components: {
      ListItem,
    },
    props: {
      block: {
        type: Object,
        required: true,
      },
    },
    methods: {
      handleShowBookPopup(target) {
        this.$emit('show-book-mobile', target);
      },
      handleShowNextSeckill(next) {
        this.$emit('show-next-seckill', next);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .seckill-list-block {
    &-title {
      display: block;
      width: 495px;
      height: 52px;
      margin: 0 auto;
    }
  }
</style>
